import React, { useState } from "react";
import { useQuery, useMutation, gql } from "@apollo/client";
import SideMenu from "../../../components/SideMenu";
import SimpleTextInput from "../../../components/forms/SimpleTextInput";
import TitleHeading from "../../../components/TitleHeading";
import SimpleSelect from "../../../components/forms/SimpleSelect";
import SimpleDateInput from "../../../components/forms/SimpleDateInput";
import SearchBar from "../../../components/search/SearchBar";
import { useAuth0 } from "../../../react-auth0-spa";

const SUPPLIERS = gql`
  query GetSuppliers {
    inventory_account(where: { account_roles: { role: { id: { _eq: 2 } } } }) {
      id
      name: local_name
    }
  }
`;

const ADD_SUPPLIER_QUOTE = gql`
  mutation AddQuote(
    $supplier_product_id: Int!
    $currency_code: String!
    $min_qty: Int!
    $unit_cost: numeric!
    $notes: String!
    $valid_from: timestamptz!
    $valid_to: timestamptz!
    $location_id: Int!
    $user_id: String!
    $supplier_quote_reference: String!
  ) {
    insert_inventory_supplier_quote_one(
      object: {
        user_id: $user_id
        supplier_quote_reference: $supplier_quote_reference
        supplier_product_id: $supplier_product_id
        currency_code: $currency_code
        min_qty: $min_qty
        unit_cost: $unit_cost
        notes: $notes
        valid_from: $valid_from
        valid_to: $valid_to
        location_id: $location_id
        folder: { data: { user_id: $user_id } }
      }
    ) {
      id
    }
  }
`;

const CURRENCY_CODES = gql`
  query CurrencyCodes {
    inventory_currency {
      id: currency_code
      name: currency_code
    }
  }
`;

const SUPPLIER_PRODUCTS = gql`
  query SupplierQuotes($supplier_id: Int!) {
    inventory_supplier_product(where: { account: { id: { _eq: $supplier_id } } }) {
      id
      supplier_product_name
      supplier_product_reference
      product {
        case_qty
        base_product {
          base_product_name
          base_product_description
        }
      }
    }
  }
`;

const LOCATIONS = gql`
  query GetLocations {
    inventory_location {
      id
      name: location_name
    }
  }
`;

const AddSupplierQuote = () => {
  const [inputs, setInputs] = useState({ supplier_id: -1, valid_to: "2099-12-31T11:59:59" });
  const [successCode, setSuccessCode] = useState(0);
  const [addSupplierQuote, { loading: mutationLoading, error: mutationError }] = useMutation(
    ADD_SUPPLIER_QUOTE,
    {
      onCompleted() {
        setSuccessCode(200);
      },
      onError() {
        setSuccessCode(0);
      },
    }
  );

  const { loading: loading_currencies, error: error_currencies, data: currencies } = useQuery(
    CURRENCY_CODES,
    {
      fetchPolicy: "network-only",
    }
  );

  const {
    loading: loading_suppliers,
    error: error_suppliers,
    data: suppliers,
    refetch: refetchSuppliers,
  } = useQuery(SUPPLIERS, {
    fetchPolicy: "network-only",
  });

  const {
    loading: loading_products,
    error: error_products,
    data: products,
    refetch: refetchproducts,
  } = useQuery(SUPPLIER_PRODUCTS, {
    variables: { supplier_id: inputs.supplier_id },
    fetchPolicy: "network-only",
  });

  const transformproducts = supplier_products => {
    if (supplier_products == null) return [];
    const products = supplier_products.inventory_supplier_product;
    console.log(products);

    return products
      ? products.map(p => {
          return {
            id: p.id,
            name:
              p.supplier_product_reference +
              " (" +
              p.supplier_product_name +
              " - " +
              p.product.case_qty +
              ") - " +
              p.product.base_product.base_product_name +
              " (" +
              p.product.base_product.base_product_description +
              ")",
          };
        })
      : [];
  };

  const {
    loading: loading_locations,
    error: error_locations,
    data: locations,
    refetch: refreshLocations,
  } = useQuery(LOCATIONS, {
    fetchPolicy: "network-only",
  });

  const handleInputChange = event => {
    event.persist();
    console.log(inputs);

    setInputs(inputs => ({
      ...inputs,
      [event.target.name]: event.target.value,
    }));
    refetchproducts();
  };

  const resetForm = event => {
    if (event) {
      event.preventDefault();
    }
    setInputs({
      name: "",
    });
    setSuccessCode(0);
  };

  const handleSubmit = event => {
    if (event) {
      event.preventDefault();
    }
    addSupplierQuote({
      variables: {
        supplier_product_id: inputs.supplier_product_id,
        supplier_quote_reference: inputs.quote_reference,
        currency_code: inputs.currency_code,
        product_id: inputs.product_id,
        min_qty: inputs.min_qty,
        unit_cost: inputs.unit_cost,
        valid_from: inputs.valid_from,
        valid_to: inputs.valid_to,
        notes: inputs.notes,
        location_id: inputs.location_id,
        user_id: user_id,
      },
    });
  };

  const { user } = useAuth0();
  const user_id = user ? user.sub : null;

  if (currencies == null || loading_currencies) return null;
  if (locations == null || loading_locations) return null;
  if (suppliers == null || loading_suppliers) return null;

  return (
    <div className="bg-gray-100 bg-opacity-25">
      <div className="hidden xl:block">
        <SideMenu
          menuOpen={true}
          layout={"large"}
          selectedMainMenu="Sales"
          selectedSubMenu="add-supplier-quotes"
        />
      </div>
      <div className="block xl:hidden">
        <SideMenu
          menuOpen={false}
          layout={"mobile"}
          selectedMainMenu="Sales"
          selectedSubMenu="add-supplier-quotes"
        />
      </div>

      <div className="flex flex-row">
        <div className="xl:w-3/12 hidden xl:block">&nbsp;</div>
        <div className="xl:w-9/12 w-full">
          <div className="container max-w-screen-xl lg:pr-8 mt-20 xl:mt-0 leading-normal tracking-normal overflow-x-hidden overflow-y-hidden">
            <SearchBar />
            <div className="flex pt-4 mb-4">
              <div className="w-full h-auto  ml-2">
                <div className="fixed xl:relative xl:top-auto top-0 pt-8 pb-4 xl:pl-0 w-full bg-white xl:bg-transparent z-50 xl:left-auto left-0 xl:ml-0 pl-16 border-b xl:border-none">
                  <TitleHeading label="Supplier Quotes &gt; Add a new Supplier Quote" />

                  {successCode === 200 && (
                    <div
                      className="p-2 bg-green-800 items-center text-indigo-100 leading-none lg:rounded-full flex lg:inline-flex"
                      role="alert"
                    >
                      <span className="flex rounded-full bg-green-500 uppercase px-2 py-1 text-xs font-bold mr-3">
                        Success
                      </span>
                      <span className="font-semibold mr-2 text-left flex-auto">
                        The Supplier Quote was added successfully.
                      </span>
                    </div>
                  )}
                  {mutationError && (
                    <div
                      className="p-2 bg-red-800 items-center text-indigo-100 leading-none lg:rounded-full flex lg:inline-flex"
                      role="alert"
                    >
                      <span className="flex rounded-full bg-red-500 uppercase px-2 py-1 text-xs font-bold mr-3">
                        Error
                      </span>
                      <span className="font-semibold mr-2 text-left flex-auto">
                        There was a problem with the data - please check.
                      </span>
                    </div>
                  )}
                </div>
                <form className="w-full flex flex-col lg:flex-row" onSubmit={handleSubmit}>
                  <div className="w-full lg:w-1/2 p-4 lg:p-0">
                    <div className="flex flex-wrap mb-2">
                      <SimpleTextInput
                        placeholder="Enter a Supplier Quote Reference (leave blank for auto-generation)"
                        value_ref={inputs.quote_reference}
                        required={true}
                        change_handler={handleInputChange}
                        label="Quote Reference"
                        id_ref="quote_reference"
                      />
                    </div>
                    <div className="flex flex-wrap mb-2">
                      <SimpleSelect
                        placeholder="Select the Supplier"
                        change_handler={handleInputChange}
                        label="Supplier"
                        options={suppliers.inventory_account}
                        id_ref="supplier_id"
                        add_url="/suppliers/add"
                        refresh_handler={refetchSuppliers}
                        required
                        name_func={option => {
                          return option.name;
                        }}
                      />
                    </div>

                    <div className="flex flex-wrap mb-2">
                      <SimpleSelect
                        placeholder="Select the Supplier Item from product"
                        change_handler={handleInputChange}
                        label="Supplier Item"
                        options={transformproducts(products)}
                        id_ref="supplier_product_id"
                        add_url="/products/supplier-product/add"
                        refresh_handler={refetchproducts}
                        required
                        name_func={option => {
                          return option.name;
                        }}
                      />
                    </div>

                    <div className="flex flex-wrap mb-2">
                      <SimpleSelect
                        placeholder="Select the Currency"
                        change_handler={handleInputChange}
                        label="Currency"
                        options={currencies.inventory_currency}
                        id_ref="currency_code"
                        required
                        name_func={option => {
                          return option.name;
                        }}
                      />
                      <SimpleSelect
                        placeholder="Select the Location"
                        change_handler={handleInputChange}
                        label="Location"
                        options={locations.inventory_location}
                        id_ref="location_id"
                        required
                        name_func={option => {
                          return option.name;
                        }}
                      />
                    </div>
                    <div className="flex flex-wrap mb-2">
                      <SimpleDateInput
                        placeholder="Select the Timestamp"
                        change_handler={handleInputChange}
                        label="Valid From"
                        id_ref="valid_from"
                        value_ref={inputs.valid_from}
                        required
                      />
                    </div>
                    <div className="flex flex-wrap mb-2">
                      <SimpleDateInput
                        placeholder="Select the Timestamp"
                        change_handler={handleInputChange}
                        label="Valid To"
                        id_ref="valid_to"
                        value_ref={inputs.valid_to}
                        required
                      />
                    </div>

                    <div className="flex flex-wrap mb-2">
                      <SimpleTextInput
                        placeholder="Enter min case qty"
                        value_ref={inputs.min_qty}
                        required={true}
                        change_handler={handleInputChange}
                        label="min qty"
                        id_ref="min_qty"
                      />
                    </div>
                    <div className="flex flex-wrap mb-2">
                      <SimpleTextInput
                        placeholder="Enter price per unit"
                        value_ref={inputs.unit_cost}
                        required={true}
                        change_handler={handleInputChange}
                        label="unit price"
                        id_ref="unit_cost"
                      />
                    </div>

                    <div className="flex flex-wrap mb-2">
                      <SimpleTextInput
                        placeholder="Enter notes"
                        value_ref={inputs.notes}
                        change_handler={handleInputChange}
                        label="notes"
                        id_ref="notes"
                      />
                    </div>

                    {successCode !== 200 && (
                      <button
                        className="flex-shrink-0 bg-teal-500 hover:bg-teal-700 border-teal-500 hover:border-teal-700 text-sm border-4 text-white py-1 px-2 rounded"
                        type="submit"
                      >
                        Add
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSupplierQuote;
